// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ts","title":"tt","notSelected":"tu","duration":"tv","image":"tw","infoWrapper":"tx","description":"ty"};